import { useEffect, useState } from "react";
import { Button, Grid, Typography } from "@mui/material";
import { Paper } from "@mui/material";
import CashlessEconomyParticipantsDataTable from "./dataTable";
import CashlessEconomyParticipantsCreate from "./create";
import { participant_getAll } from "../../../../../../controllers/company/cashless/ParticipantsController";

export default function CashlessEconomyParticipants({economy})
{
    const [participants,setParticipants] = useState([]);

    useEffect(()=>{
        handleGetParticipants();
    },[]);

    const handleGetParticipants = async () => {
        const response = await participant_getAll(economy.uuid);
        if(response.success === true)
        {
            setParticipants(response.data.participants);
        }
    }
    
    const onUpdate = async () => {

    }

    return(
        <Grid container spacing={3}>  
            <Grid item xs={12}>
                <CashlessEconomyParticipantsCreate economy={economy} onUpdate={()=>onUpdate()}/>
            </Grid>
            <Grid item xs={12}>
                <CashlessEconomyParticipantsDataTable participants={participants} />
            </Grid>
        </Grid>
    )
}